export const NotifyGuestType = {
  reservations: "reservations"
};
